function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #5865F2;\n        opacity: 0;\n      }\n    "));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "icon_telegram",
  transform: "translate(-1324 -4052)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "\\u77E9\\u5F62_627",
  "data-name": "\\u77E9\\u5F62 627",
  className: "cls-1",
  width: 18,
  height: 18,
  transform: "translate(1324 4052)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icon_telegram-2",
  "data-name": "icon_telegram",
  d: "M1388.4,3709.625l3.284,1.251,1.27,4.172a.384.384,0,0,0,.614.188l1.83-1.523a.538.538,0,0,1,.666-.019l3.3,2.447a.385.385,0,0,0,.606-.239l2.418-11.875a.39.39,0,0,0-.518-.449l-13.475,5.307A.4.4,0,0,0,1388.4,3709.625Zm4.35.585,6.417-4.035a.113.113,0,0,1,.135.181l-5.3,5.025a1.132,1.132,0,0,0-.341.67l-.18,1.365a.165.165,0,0,1-.323.024l-.694-2.489A.665.665,0,0,1,1392.749,3710.21Z",
  transform: "translate(-61.898 351.449)"
}));

function SvgIconTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTelegram);
export default __webpack_public_path__ + "static/media/icon_telegram.b574c240.svg";
export { ForwardRef as ReactComponent };